import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from './Shared';
export function Guarantee() {
  return <Section className="max-w-3xl" data-id="element-68" data-mp="3gg0yw2enzvx4">
      <div className="glass-panel rounded-3xl border-brand-teal/30 p-8 text-center md:p-12" data-id="element-69" data-mp="3gh3qydnq44em">
        <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-teal" data-id="element-70" data-mp="32lrmvfnoh1l1" />
        <h2 className="mt-5 font-display text-2xl font-bold text-brand-ink md:text-3xl" data-id="element-71" data-mp="36pzb7bq84fiq">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>
        <p className="mt-5 text-brand-text" data-id="element-72" data-mp="38qtqszerhoj">
          Descargás el Atlas. Abrís el Tomo II. Lo usás en tu próxima sesión.
        </p>
        <p className="mt-4 text-brand-text" data-id="element-73" data-mp="3ldamrdmenziu">
          Si en 7 días no es exactamente lo que esperabas: devolución del 100%
          sin formularios, sin drama, sin preguntas.
        </p>
        <p className="mt-6 font-semibold text-brand-teal" data-id="element-74" data-mp="29yxdpewb9omv">
          Tasa de devoluciones: menos del 1%.
        </p>
      </div>
    </Section>;
}
export function Footer() {
  return <footer className="border-t border-brand-gold/35 bg-brand-deep py-12 text-white" data-id="element-75" data-mp="3l9ahbtogro9p">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-76" data-mp="3gah1hulpfl6d">
        <h3 className="font-display text-2xl font-bold text-brand-goldLight md:text-3xl" data-id="element-77" data-mp="3gck0h44u4on8">
          LUMEN AKASHA™
        </h3>
        <p className="mx-auto mt-3 max-w-2xl text-white/80" data-id="element-78" data-mp="3q8wrtvcwqqet">
          El sistema visual de geometría sagrada N°1 para terapeutas en
          Argentina.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 text-sm text-brand-goldLight sm:flex-row sm:flex-wrap sm:gap-6" data-id="element-79" data-mp="8178js5jp0n7">
          <a className="transition-colors duration-150 hover:text-brand-paper" href="mailto:soportelumenakasha@gmail.com" data-id="element-80" data-mp="htd236bg3q4i">
            soportelumenakasha@gmail.com
          </a>
          <a className="transition-colors duration-150 hover:text-brand-paper" href="https://wa.me/5491153399780" data-id="element-81" data-mp="qsqfub6lr0v1">
            WhatsApp 11 5339-9780
          </a>
          <a className="transition-colors duration-150 hover:text-brand-paper" href="https://instagram.com/lumen.akasha" data-id="element-82" data-mp="tvw8ij57pjh1">
            @lumen.akasha
          </a>
          <a className="transition-colors duration-150 hover:text-brand-paper" href="https://www.lumenakasha.com" data-id="element-83" data-mp="13t0tifnbn8w9">
            www.lumenakasha.com
          </a>
        </div>
        <div className="mt-10 space-y-2 text-xs text-white/50" data-id="element-84" data-mp="1ckkp4swnx2n0">
          <p data-id="element-85" data-mp="1hkfegs0shk5y">
            © Lumen Akasha™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p data-id="element-86" data-mp="1mhpa4perus28">
            Ley 25.326 — Protección de Datos Personales — República Argentina
          </p>
        </div>
        <p className="mx-auto mt-8 max-w-2xl font-serif text-base italic text-brand-goldLight/80" data-id="element-87" data-mp="3ob55u0ppux42">
          “El terapeuta que tiene un sistema aplica con confianza. El que aplica
          con confianza genera resultados. El que genera resultados crece.”
        </p>
      </div>
    </footer>;
}